// Thin wrapper around Google Analytics 4 gtag + page-view tracking on
// client-side route changes. Falls back to no-op if gtag isn't loaded
// (e.g. ad blockers, local dev without network).

export function track(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    /* swallow — analytics must never break the app */
  }
}

export function trackPageView(path) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path || window.location.pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  } catch {
    /* no-op */
  }
}

// Named events used across the app — keep these stable so GA4 reports
// don't fragment.
export const EVENTS = {
  APPLY_CLICK: "apply_click",
  LEAD_SUBMIT: "lead_submit",
  MLO_LOGIN: "mlo_login",
  MLO_LANDING_VIEW: "mlo_landing_view",
  LIBRARY_ASSET_DOWNLOAD: "library_asset_download",
  LIBRARY_FOLDER_SHARE: "library_folder_share",
  PARTNER_APPLY_SUBMIT: "partner_apply_submit",
};
